<template>
  <div>
    <v-modal-contents ref="modal_contents_agree">
      <template v-slot:title>

        <div class="terms_of_use__title mt-30 pl-3 ">
          <div v-if="language == 'ru'" class="h2_title">Пользовательское соглашение!</div>
          <div v-else-if="language == 'en'" class="h2_title">Terms of use!</div>
        </div>

      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <p v-if="language == 'ru'" class="red">ТЕКСТ НАХОДИТСЯ В РАЗРАБОТКЕ</p>
          <p v-else-if="language == 'en'" class="red">TEXT IS UNDER DEVELOPMENT</p>
          <div class="mt-30">
            <button v-if="language == 'ru'" class="px-30 btn_bordered "
                    @click="$refs.modal_contents_agree.modal_open()">
              Прочитал
            </button>
            <button v-else-if="language == 'en'" class="px-30 btn_bordered"
                    @click="$refs.modal_contents_agree.modal_open()">
              Read
            </button>
          </div>
        </div>
      </template>
    </v-modal-contents>

    <v-form ref="form" class="form_upload" v-model="valid"  lazy-validation>
      <div class="row">
        <div class="col-12 col-md-6 py-0">
          <div class="form_upload__item">
            <label v-if="language == 'ru'" for="name">ФИО <span class="red"> *</span></label>
            <label v-else-if="language == 'en'" for="name">Full name <span class="red"> *</span></label>
            <v-text-field v-if="language == 'ru'"
                          v-model="name"
                          :rules="nameRulesRu"
                          required=""
                          solo
                          id="name"
            ></v-text-field>
            <v-text-field v-else-if="language == 'en'"
                          v-model="name"
                          :rules="nameRules"
                          required=""
                          solo
                          id="name"
            ></v-text-field>
          </div>
        </div>

        <div class="col-12 col-md-6 py-0">
          <div class="form_upload__item item_tel position-relative">
            <label v-if="language == 'ru'" for="tel">Телефон <span class="red"> *</span></label>
            <label v-else-if="language == 'en'" for="tel">Телефон <span class="red"> *</span></label>
            <v-text-field v-if="language == 'ru'"
                          v-model="tel_input"
                          :rules="tel_inputRulesRu"
                          required
                          solo
                          id="tel"
                          oninput="this.value = this.value.replace(/[^\d]/g,'');"
                          class="tel_input"
            ></v-text-field>
            <v-text-field v-else-if="language == 'en'"
                          v-model="tel_input"
                          :rules="tel_inputRules"
                          required
                          solo
                          id="tel"
                          oninput="this.value = this.value.replace(/[^\d]/g,'');"
                          class="tel_input"
            ></v-text-field>

            <v-select
                :items="tel_items"
                :menu-props="{ contentClass: 'wrap_selfilter' }"
                item-value="sel_id"
                v-model="defaultSelectedTel.sel_id"
                solo
                class="tel_sel__btn d-flex align-items-center"
                append-icon="mdi mdi-chevron-down"
            >
              <template slot="selection" slot-scope="data">
                <img :src="data.item.icon"></img>
                <span class="tel_kod">{{ data.item.kod }}</span>
              </template>

              <template slot="item" slot-scope="data">
                <img class="pr-2" :src="data.item.icon"></img>
                <span>{{ data.item.name }}</span>
              </template>
            </v-select>

          </div>
        </div>

        <div class="col-12 col-md-6 py-0">
          <div class="form_upload__item">
            <label v-if="language == 'ru'" for="name">Город <span class="red"> *</span></label>
            <label v-else-if="language == 'en'" for="name">City <span class="red"> *</span></label>
            <v-text-field v-if="language == 'ru'"
                          v-model="city"
                          :rules="cityRulesRu"
                          required=""
                          solo
                          id="name"
            ></v-text-field>
            <v-text-field v-else-if="language == 'en'"
                          v-model="city"
                          :rules="cityRules"
                          required=""
                          solo
                          id="name"
            ></v-text-field>
          </div>
        </div>

        <div class="col-12 col-md-6 py-0">
          <div class="form_upload__item">
            <label for="email">E-mail <span class="red"> *</span></label>
            <v-text-field v-if="language == 'ru'"
                          v-model="email"
                          :rules="emailRulesRu"
                          required
                          solo
                          id="email"
            ></v-text-field>
            <v-text-field v-else-if="language == 'en'"
                          v-model="email"
                          :rules="emailRules"
                          required
                          solo
                          id="email"
            ></v-text-field>
          </div>
        </div>

        <div class="col-12 col-md-6 py-0">
          <div class="form_upload__item item_tel position-relative">
            <label v-if="language == 'ru'" for="type_of_appeal">Выберите удобный вид связи</label>
            <label v-else-if="language == 'en'" for="type_of_appeal">Choose a convenient way of communication</label>
            <v-select
                :items="type_appeal"
                :menu-props="{ contentClass: 'wrap_selfilter' }"
                item-value="sel_id"
                v-model="type_appeal_sel.sel_id"
                solo
                class=" d-flex align-items-center"
                append-icon="mdi mdi-chevron-down"
                id="type_of_appeal"
            >
              <template slot="selection" slot-scope="data">
                <img :src="data.item.icon"></img>
                <span class="pl-2" v-if="language == 'ru'">{{ data.item.name }}</span>
                <span class="pl-2" v-else-if="language == 'en'">{{ data.item.eng_name }}</span>
              </template>

              <template slot="item" slot-scope="data">
                <img :src="data.item.icon"></img>
                <span class="pl-2" v-if="language == 'ru'">{{ data.item.name }}</span>
                <span class="pl-2" v-else-if="language == 'en'">{{ data.item.eng_name }}</span>
              </template>
            </v-select>
          </div>
        </div>


        <div class="col-12 col-md-12 py-0">
          <div class="form_upload__item d-flex align-items-center justify-content-between mt-5">
            <v-checkbox v-if="language == 'ru'"
                        v-model="checkbox"
                        :rules="[(v) => !!v || 'Вы должны подтвердить прочтение соглашения!']"
                        required
                        color="red"
            >

              <template v-slot:label>
                Я подтверждаю, что прочитал <a href="#" class="mx-1"
                                               @click="$refs.modal_contents_agree.modal_open('scroll_false')">соглашение</a>
                и согласен с ним.
              </template>
            </v-checkbox>
            <v-checkbox v-if="language == 'en'"
                        v-model="checkbox"
                        :rules="[(v) => !!v || 'You must agree to continue!']"
                        required
                        color="red"
            >
              <template v-slot:label>
                I confirm that I have read <a href="#" class="mx-1"
                                              @click="$refs.modal_contents_agree.modal_open('scroll_false')">the
                agreement</a> and agree with it.
              </template>
            </v-checkbox>
            <div class="btn_form">
              <v-btn :disabled="!valid" class="px-30 btn_red" @click="sendForm">
                <span v-if="language == 'ru'">Отправить</span>
                <span v-else-if="language == 'en'">Send</span>
              </v-btn>

              <!--            <v-btn color="error" class="mr-4" @click="reset"> Reset Form</v-btn>-->

              <!--            <v-btn color="warning" @click="resetValidation"> Reset Validation</v-btn>-->
            </div>
          </div>

        </div>


      </div>
    </v-form>

  </div>

</template>
<script>
import VModalContents from './modal_contents.vue';

export default {
  name: "form_contact",
  components: {
    VModalContents: VModalContents,
  },
  props: {
    lang: String,
  },
  delimiters: ["${", "}"], // Avoid Twig conflicts
  data() {
    return {
      valid: true,
      language: this.lang,

      terms_of_use: false,

      name: "",
      city: "",
      nameRules: [
        (v) => (!!v && this.language == "en") || "Name is required",
        (v) => (v && v.length >= 3) || "Name must be less than 3 characters",
      ],
      nameRulesRu: [
        (v) => (!!v && this.language == "ru") || "Поле 'Имя' не может быть пустым",
        (v) => (v && v.length >= 3) || "Поле 'Имя' не может быть меньше 3 символов",
      ],

      cityRules: [
        (v) => (!!v && this.language == "en") || "City is required",
        (v) => (v && v.length >= 3) || "City must be less than 3 characters",
      ],
      cityRulesRu: [
        (v) => (!!v && this.language == "ru") || "Поле 'Город' не может быть пустым",
        (v) => (v && v.length >= 3) || "Поле 'Город' не может быть меньше 3 символов",
      ],

      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      emailRulesRu: [
        (v) => !!v || "E-mail обязателен для заполнения",
        (v) => /.+@.+\..+/.test(v) || "E-mail заполнен неправильно",
      ],

      type_appeal: [
        {
          sel_id: 0,
          name: "Звонок",
          eng_name: "Phone",
          icon: "/local/templates/international/img/svg/Telefone.svg",

        },
        {
          sel_id: 1,
          name: "Почта",
          eng_name: "E-mail",
          icon: "/local/templates/international/img/svg/email.svg",
        },
        {
          sel_id: 2,
          name: "Telegram",
          eng_name: "Telegram",
          icon: "/local/templates/international/img/svg/telegramm.svg",
        },
        {
          sel_id: 3,
          name: "WhatsApp",
          eng_name: "WhatsApp",
          icon: "/local/templates/international/img/svg/watsapp.svg",
        },
        {
          sel_id: 4,
          name: "Viber",
          eng_name: "Viber",
          icon: "/local/templates/international/img/svg/viber.svg",
        },
      ],
      type_appeal_sel: {
        sel_id: 0,
      },

      tel_select: null,
      tel_items: [
        {
          sel_id: 0,
          name: "Россия",
          icon: "/local/templates/international/img/FlagRossii.svg",
          kod: "+7",
        },
        // {
        //   sel_id: 2,
        //   name: "Польша",
        //   icon: "/local/templates/international/img/FlagPaulshi.svg",
        //   kod: "+2",
        // },
        {
          sel_id: 1,
          name: "Казахстан",
          icon: "/local/templates/international/img/FlagKazakhstana.svg",
          kod: "+7",
        },
      ],

      defaultSelectedTel: {
        sel_id: 0,
      },

      tel_input: "",
      tel_inputRules: [
        (v) => !!v || "Phone is required",
        (v) => /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/.test(v) || "Phone must be valid",
      ],
      tel_inputRulesRu: [
        (v) => !!v || "Поле 'Телефон' обязательно для заполнения",
        (v) => /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/.test(v) || "Телефон заполнен неправильно",
      ],

      checkbox: false,

    };
  },


  methods: {
    sendForm() {
      if (!this.$refs.form.validate()) return false;
      var VueObject = this;
      $.ajax({
        "type": "POST",
        "url": "/ajax/contacts_form.php",
        "data": {
          "ajaxPost": "Y",
          "name": VueObject.name,
          "phone": VueObject.tel_items[VueObject.defaultSelectedTel.sel_id]["kod"] + " " + VueObject.tel_input,
          "email": VueObject.email,
          "type": VueObject.type_appeal[VueObject.type_appeal_sel.sel_id]["name"],
          "city": VueObject.city,
        },
        "success": function (res) {
          $(".text_result").slideDown(300);
          $(".text_result").delay(3000).slideUp(300);
          setTimeout(function () {
            window.location.reload()
          }, 3000);
        },
        "error": function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.status);
          console.log(thrownError);
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },

};
</script>


<style lang="scss">
@import "../../theme/_variable.scss";


</style>

<style lang="scss" scoped>


.drag_form {
  background: rgba(249, 66, 55, 0.06);
  border: 1px dashed #f94237 !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "RobotoRegular";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000000;
  opacity: 0.7;
  text-align: center;

}

</style>